const PRINT_CONTAINER_CLASS = "detail-print-container";

const PRINT_PLACEHOLDER_TEXTS = new Set(["데이터를 입력해주세요"]);

function isPlaceholderOnly(text, placeholder) {
    const trimmed = text?.trim() ?? "";
    if (!trimmed) {
        return true;
    }
    if (PRINT_PLACEHOLDER_TEXTS.has(trimmed)) {
        return true;
    }
    if (placeholder?.trim() && trimmed === placeholder.trim()) {
        return true;
    }
    return false;
}

function stripPlaceholderText(root) {
    root
        .querySelectorAll(
            ".detail-print-text, .align-text-div, .incident-report-kv-text, .edit-input, .asset-detail-kv-value--multiline"
        )
        .forEach((el) => {
            if (isPlaceholderOnly(el.textContent)) {
                el.textContent = "";
            }
        });
}

function findPrintSource() {
    return (
        document.querySelector(
            ".detail-view-tab-panel .detail-list-scroll, .asset-view-tab-panel .detail-list-scroll, " +
                ".detail-view-tab-panel .asset-detail-list-scroll, .asset-view-tab-panel .asset-detail-list-scroll"
        ) ??
        document.querySelector(".detail-list-scroll, .asset-detail-list-scroll")
    );
}

function removeAttachmentPanels(root) {
    root.querySelectorAll(".detail-list-panel, .asset-detail-panel").forEach((panel) => {
        const head = panel.querySelector(".detail-list-panel-head, .asset-detail-panel-head");
        const title = head?.textContent?.trim() ?? "";
        if (title === "첨부" || title.startsWith("첨부")) {
            panel.remove();
        }
    });
}

function extractSignBlock(clone) {
    const signBlock = document.createElement("div");
    signBlock.className = "detail-print-sign-block";

    const memoScroll = clone.querySelector(
        ".detail-list-col--memo .detail-list-col-scroll, .asset-detail-col--memo .detail-list-col-scroll"
    );

    const searchRoots = memoScroll ? [memoScroll] : [clone];

    searchRoots.forEach((root) => {
        Array.from(root.children).forEach((child) => {
            if (child.matches(".detail-list-panel, .asset-detail-panel")) {
                return;
            }
            if (child.querySelector(".sign-border")) {
                signBlock.appendChild(child);
            }
        });
    });

    clone.querySelector(".detail-list-col--memo, .asset-detail-col--memo")?.remove();

    return signBlock.childElementCount > 0 ? signBlock : null;
}

function reorderForPrint(clone) {
    removeAttachmentPanels(clone);

    const signBlock = extractSignBlock(clone);
    if (!signBlock) {
        return clone;
    }

    const stack =
        clone.querySelector(".detail-list-v2-stack") ??
        clone.querySelector(".detail-list-panel-grid-3") ??
        clone;

    stack.insertBefore(signBlock, stack.firstChild);
    return clone;
}

function prepareClone(source) {
    const clone = source.cloneNode(true);

    clone
        .querySelectorAll(
            ".print-none, .print-hidden, .rollup-btn-container, .ir-section-toolbar, .ir-legend-bar"
        )
        .forEach((el) => el.remove());
    clone
        .querySelectorAll(
            ".detail-kv-actions button, .detail-list-summary-action, .detail-list-summary-print"
        )
        .forEach((el) => el.remove());

    clone.querySelectorAll("textarea").forEach((ta) => {
        const text = isPlaceholderOnly(ta.value, ta.placeholder) ? "" : ta.value?.trim() ?? "";
        const div = document.createElement("div");
        div.className = "detail-print-text";
        div.textContent = text;
        ta.replaceWith(div);
    });

    clone.querySelectorAll("input").forEach((input) => {
        if (input.type === "hidden") {
            input.remove();
            return;
        }
        const span = document.createElement("span");
        span.className = "detail-print-text";
        span.textContent = input.value || "";
        input.replaceWith(span);
    });

    stripPlaceholderText(clone);

    return reorderForPrint(clone);
}

/**
 * 상세/보고서 인쇄 — 본문을 클론해 전용 컨테이너에 렌더링 후 인쇄 (레이아웃 깨짐 방지)
 */
export function printDetailReport() {
    const source = findPrintSource();
    if (!source) {
        window.print();
        return;
    }

    const printContainer = document.createElement("div");
    printContainer.className = PRINT_CONTAINER_CLASS;
    printContainer.appendChild(prepareClone(source));

    document.body.appendChild(printContainer);
    document.body.classList.add("detail-print-mode");

    const cleanup = () => {
        document.body.classList.remove("detail-print-mode");
        printContainer.remove();
        window.removeEventListener("afterprint", cleanup);
    };

    window.addEventListener("afterprint", cleanup);
    requestAnimationFrame(() => window.print());
}
